import { getContentPlatformPropertyDescription, getContentPlatformPropertyLabel } from 'content-management-data-lib';
import { createPropertyDefinitionFromOverride } from './filterPropertyUtils';
import { STANDARD_PROPERTY_DEFINITION_TYPES } from '../constants/properties';
function getPropertyLabel(propertyName, isStandardProperty) {
  return isStandardProperty ? getContentPlatformPropertyLabel(propertyName) : propertyName;
}
// TODO: write unit tests
export const createPropertyDefinitionMapForProperties = ({
  standardPropertiesVisibilityAndOptionsMap,
  propertyOverrides = {}
}) => {
  const finalPropertyDefinitionMap = {};
  const mergedPropertyOverrides = Object.assign({}, propertyOverrides.standardPropertyMap, propertyOverrides.customPropertyMap);
  const propertyNames = new Set([...Object.keys(STANDARD_PROPERTY_DEFINITION_TYPES), ...Object.keys(mergedPropertyOverrides)]);
  propertyNames.forEach(propertyName => {
    var _standardPropertiesVi;
    const isStandardProperty = (propertyName in STANDARD_PROPERTY_DEFINITION_TYPES);
    finalPropertyDefinitionMap[propertyName] = createPropertyDefinitionFromOverride(Object.assign({
      name: propertyName,
      hidden: !!(isStandardProperty && (_standardPropertiesVi = standardPropertiesVisibilityAndOptionsMap[propertyName]) !== null && _standardPropertiesVi !== void 0 && _standardPropertiesVi.hidden),
      label: getPropertyLabel(propertyName, isStandardProperty),
      description: isStandardProperty ? getContentPlatformPropertyDescription(propertyName) : undefined,
      type: STANDARD_PROPERTY_DEFINITION_TYPES[propertyName]
    }, standardPropertiesVisibilityAndOptionsMap[propertyName] || {}, mergedPropertyOverrides[propertyName] || {}));
  });
  return finalPropertyDefinitionMap;
};
const isShownPropertyFilterConfig = propertyFilterConfig => !propertyFilterConfig.hidden;
export function createFiltersConfiguration({
  propertyFilterConfigs = {}
}) {
  const quickFilterPropertyNames = [];
  const filterTagsConfigMap = {};
  Object.keys(propertyFilterConfigs).forEach(propertyName => {
    const property = propertyFilterConfigs[propertyName];
    if (isShownPropertyFilterConfig(property)) {
      const {
        hasQuickFilter,
        filterTagsConfig
      } = property;

      // Configure whether a property has a quick filter
      if (hasQuickFilter) {
        quickFilterPropertyNames.push(propertyName);
      }

      // Configure property's filter tags
      if (filterTagsConfig) {
        filterTagsConfigMap[propertyName] = filterTagsConfig;
      }
    }
  });
  return {
    quickFilterPropertyNames,
    filterTagsConfig: filterTagsConfigMap
  };
}